export const ANTHAHUB_BASE_URL = 'http://localhost:5001';
